import { useEffect } from "react";
import { useSelector } from "react-redux";
import useMultiNotification from "../../hooks/useNotification";
import { getAllNewsLetterSubscribers } from "../../redux-toolkit/slices/newsLetterSlice";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import AppLoader from "../Items/loader/AppLoader";
import { Table } from "antd"; // import antd Table

export default function ViewNewsLetterSubscribers() {
  const dispatch = useAppDispatch();
  const { contextHolder, openNotification } = useMultiNotification();
  const { newsLetters, isApiLoading, isError, errors } = useSelector(
    (state: RootState) => state.newsLetter
  );
  useEffect(() => {
    dispatch(getAllNewsLetterSubscribers());
  }, []);

  if (isApiLoading) {
    return <AppLoader />;
  }

  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Subscribed At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date: string) => new Date(date).toLocaleString(),
    },
  ];

  return (
    <>
      {contextHolder}
      <h1>News Letter Subscribers</h1>
      <Table
        dataSource={newsLetters}
        columns={columns}
        rowKey="id"
        pagination={{ pageSize: 10 }}
      />
    </>
  );
}
